document.addEventListener('click', function (event) {
  var trigger = event.target.closest('[data-mirailab-cart-drawer]');
  if (!trigger) return;

  event.preventDefault();

  var cartDrawer = document.querySelector('cart-drawer');
  var cartIcon = document.querySelector('#cart-icon-bubble');

  if (cartDrawer && typeof cartDrawer.open === 'function') {
    cartDrawer.open(cartIcon || trigger);
  } else {
    window.location.href = trigger.getAttribute('href') || '/cart';
  }
});

function mirailabSyncHeaderCartBadge(cart) {
  if (!cart) return;

  document.querySelectorAll('.cart--external--total-items').forEach(function (el) {
    el.textContent = cart.item_count > 0 ? cart.item_count : '';
  });

  document.querySelectorAll('.cart--external--icon').forEach(function (el) {
    el.setAttribute('data-item-count', cart.item_count);
  });
}

function mirailabRefreshHeaderCartBadge() {
  return fetch('/cart.js')
    .then(function (res) {
      return res.json();
    })
    .then(function (cart) {
      mirailabSyncHeaderCartBadge(cart);
      return cart;
    })
    .catch(function () {});
}

document.addEventListener('cart:update', mirailabRefreshHeaderCartBadge);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mirailabRefreshHeaderCartBadge);
} else {
  mirailabRefreshHeaderCartBadge();
}
